export default {
  props: {
    value: {
      required: true
    },

    // TODO: maybe this isnt the best place to handle casting json?
    json: {
      default: false
    }
  },

  computed: {
    resource: {
      get() {
        return this.json ? JSON.stringify(this.value) : this.value
      },

      set(newValue) {
        let out = this.json ? JSON.parse(newValue) : newValue

        this.$emit('input', out)
      }
    }
  }
}
